import React from "react";
import { motion } from "framer-motion";
import { clients } from "../Data";

const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.15,
    },
  },
};

const Clients = () => {
  return (
    <section className="clients-section container">

      <motion.h2
        className="section-heading"
        initial={{
          opacity: 0,
          y: 35,
          filter: "blur(10px)",
        }}
        whileInView={{
          opacity: 1,
          y: 0,
          filter: "blur(0px)",
        }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{
          duration: 0.8,
          ease: [0.22, 1, 0.36, 1],
        }}
      >
        Powering communication for <span>fast-growing global enterprises</span>
      </motion.h2>

      <motion.div
        className="clients-grid"
        variants={container}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.25 }}
      >
        {clients.map((item, i) => (
          <motion.div
            className="client-logo"
            key={i}
            variants={item}
            whileHover={{
              y: -8,
              scale: 1.06,
            }}
            transition={{
              type: "spring",
              stiffness: 350,
              damping: 18,
            }}
          >
            <motion.img
              src={item.img}
              alt={`${item.alt} | Onbbits`}
              animate={{
                y: [0, -4, 0],
              }}
              transition={{
                duration: 4 + (i % 4),
                repeat: Infinity,
                ease: "easeInOut",
              }}
            />
          </motion.div>
        ))}
      </motion.div>

    </section>
  );
};

export default Clients;